import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer__inner container">
        <div className="footer__grid">
          <div className="footer__brand">
            <h3 className="footer__logo">Lexington Air Systems</h3>
            <p className="footer__tagline">
              Authorized TCL HVAC distributor serving contractors and builders across New England with premium heat pump systems and expert support.
            </p>
          </div>

          <div className="footer__col">
            <h4 className="footer__heading">Products</h4>
            <Link to="/products" className="footer__link">All Heat Pumps</Link>
            <Link to="/products/breezein-series" className="footer__link">BreezeIN Series</Link>
            <Link to="/products/ultimate-25-series" className="footer__link">Ultimate 25 Series</Link>
            <Link to="/products/elite-series" className="footer__link">Elite Series</Link>
            <Link to="/products/advantage-series" className="footer__link">Advantage Series</Link>
            <Link to="/products/multi-match" className="footer__link">Multi Match</Link>
          </div>

          <div className="footer__col">
            <h4 className="footer__heading">Company</h4>
            <Link to="/why-us" className="footer__link">Why Us</Link>
            <Link to="/accessories" className="footer__link">Accessories</Link>
            <Link to="/contact" className="footer__link">Contact</Link>
          </div>

          <div className="footer__col">
            <h4 className="footer__heading">Contact</h4>
            <a href="mailto:info@lexingtonairsystems.com" className="footer__link">
              info@lexingtonairsystems.com
            </a>
            <span className="footer__link footer__link--muted">25-C Olympia Avenue, Woburn, MA 01810</span>
          </div>
        </div>

        <div className="footer__bottom">
          <p>&copy; {new Date().getFullYear()} Lexington Air Systems. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
